module.exports = __webpack_public_path__ + "img/delete.59cdc812.svg";